{
  "code": "Code",
  "codeExecute": "Run code",
  "noTestCases": "There are no any test cases to run the test",
  "retry": "Start over",
  "submitCode": "Submit the code for checking",
  "test": "Test {{ value }}",
  "tooManyInputs": "You use too many input(), in this task there should be"
}
